// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LxQ-","delete":"styles_delete__p94kB","update":"styles_update__3BgqF","add":"styles_add__1eiik"};